import Avatar from '@/core/components/Avatar/Avatar';

export default Avatar;
